<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter4">
<h1 class="left"><a id="page_38"></a><a href="#/005toc#ch4"><span class="yellow">SPICY CHICKEN WINGS WITH BLUE CHEESE DRESSING</span></a></h1>
<p class="noindent">Pack up these popular wings for your next tailgate party or picnic. They are good hot off the grill or cold along with beer and chips. Serve with Blue Cheese Dressing for dipping.</p>
<p class="hang-space1">3 pounds chicken wings (about 12)</p>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">2</sub> cup (1 stick) butter, melted</p>
<p class="hang"><sup class="frac">1</sup>/<sub class="frac">4</sub> cup fresh lemon juice</p>
<p class="hang">2 teaspoons chili powder</p>
<p class="hang">1 teaspoon salt</p>
<p class="hang">1 teaspoon paprika</p>
<p class="hang">1 garlic clove, minced</p>
<p class="hang">1 teaspoon prepared mustard</p>
<p class="hang">1 teaspoon Worcestershire sauce</p>
<p class="hang"><a href="#/057chapter47#page_89">Blue Cheese Dressing</a> for serving</p>
<p class="noindent-space1">Cut off the wing tips with kitchen scissors or a sharp knife and discard or save them for stock. Halve the wings at the joint and trim excess fat and skin. In a medium bowl, mix together the remaining ingredients except the dressing. Add the chicken wings and stir to coat. Cover and refrigerate several hours, stirring once. Bring to room temperature before grilling.</p>
<p class="noindent-space1">Prepare a grill for cooking over indirect medium heat. Remove the wings from the marinade and discard the marinade. Place the wings on a lightly sprayed or oiled grate and grill until lightly browned and cooked through, 30 to 35 minutes, turning several times. Serve with the Blue Cheese Dressing for dipping.</p>
<p class="noindent-space1">Makes 24 pieces</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 012-chapter4.vue?6f42bc8a